module.exports = __webpack_public_path__ + "static/15-5b3bbf6de5a1cb1032c1ad8b2c84b955.jpg";